@if (vm$ | async) {
    <mds-dialog dialogTitle="Visit Mapping">
        @if (clinTrakVisits?.length > 0) {
            <mds-dialog-content>
                @if (notSelectedVisitsAlert()) {
                    <medpace-alert [content]="notSelectedVisitsAlertText" [appearance]="'caution'" />
                }
                <mds-tab-group
                    [animationDuration]="'300'"
                    [disablePagination]="false"
                    [headerPosition]="'above'"
                    [tabAlign]="'start'"
                >
                    @for (groupName of getVisitsGroupName(); track groupName) {
                        <mds-tab label="{{ groupName }}" id="tab-{{ groupName }}">
                            <div class="o-grid__row tab-content">
                                <div class="o-grid__col col-width">
                                    <h5 class="header-align">{{ applicationName }}</h5>
                                    <ng-container>
                                        @for (
                                            studyMappedVisit of getStudyMappedVisitsByGroupName(groupName);
                                            track studyMappedVisit;
                                            let i = $index
                                        ) {
                                            <div class="o-grid__item">
                                                <mds-expansion-panel
                                                    id="pcs-visit-expansion-{{ studyMappedVisit.visitName.name }}"
                                                    [panelTitle]="studyMappedVisit.visitName.name"
                                                    [checkboxFormCtrl]="getFormArrayByGroupName(groupName).controls[i]"
                                                    [description]="''"
                                                    [disabled]="getFormArrayByGroupName(groupName).controls[i].disabled"
                                                    [expanded]="false"
                                                    [hideToggle]="false"
                                                    [enableCheckbox]="true"
                                                    [checkboxOptions]="{
                                                        id: studyMappedVisit.visitName.name,
                                                        name: studyMappedVisit.visitName.name,
                                                    }"
                                                    (changeEvent)="expansionPanelchangeEvent($event, i, groupName)"
                                                >
                                                    @for (
                                                        ctVisit of studyMappedVisit.patientVisitsMaster;
                                                        track ctVisit
                                                    ) {
                                                        <div class="o-grid__item mapped-visit-list">
                                                            <span class="width-auto">{{ ctVisit.visitName }}</span>
                                                            <div class="width-auto">
                                                                <mds-icon-button
                                                                    [icon]="'delete'"
                                                                    (clickEvent)="
                                                                        removeSingleClinTrakMappedVisit(
                                                                            studyMappedVisit,
                                                                            ctVisit.visitName
                                                                        )
                                                                    "
                                                                    [tooltip]="'Delete'"
                                                                    class="danger outline"
                                                                ></mds-icon-button>
                                                            </div>
                                                        </div>
                                                    }
                                                    @if (studyMappedVisit.patientVisitsMaster?.length > 0) {
                                                        <div class="o-grid__item">
                                                            <mds-button
                                                                [id]="'removeVisit-btn'"
                                                                mat-button
                                                                (clickEvent)="clearMapping(studyMappedVisit)"
                                                                label="Clear mapping"
                                                                [color]="'primary'"
                                                                [variant]="'filled'"
                                                            ></mds-button>
                                                        </div>
                                                    }
                                                </mds-expansion-panel>
                                            </div>
                                        }
                                    </ng-container>
                                </div>
                                <div class="o-grid__col col-width">
                                    <h5 class="header-align">ClinTrak</h5>
                                    <ng-container>
                                        <div class="o-grid__row">
                                            <mds-selection-list
                                                id="clintrak-visits-list"
                                                [multiple]="true"
                                                [disabled]="false"
                                                [items]="getClinTrakVisitsPerGroupName(groupName)"
                                                (selectionChange)="clinTrakVisitsSelectionChange($event, groupName)"
                                            ></mds-selection-list>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </mds-tab>
                    }
                </mds-tab-group>
            </mds-dialog-content>
        }
        @if (clinTrakVisits?.length === 0) {
            <mds-dialog-content>
                <div class="o-grid__row">
                    <div class="o-grid__field">
                        <span>There are no ClinTrak visits to map.</span>
                    </div>
                </div>
            </mds-dialog-content>
        }
        @if (clinTrakVisits?.length > 0) {
            <mds-dialog-actions [align]="'end'">
                <div class="flex flex-row gap-medpace">
                    @if (showCancelButton) {
                        <mds-button
                            [id]="'cancel-btn'"
                            mat-button
                            mat-dialog-close
                            label="Cancel"
                            variant="outline"
                        ></mds-button>
                    }
                    <mds-button
                        [id]="'map-visits-btn'"
                        mat-button
                        (clickEvent)="mapSelectedClinTrakVisits()"
                        label="Map selected visits"
                        color="primary"
                        variant="tonal"
                    ></mds-button>
                    <mds-button
                        [id]="'done-btn'"
                        mat-button
                        (clickEvent)="confirm()"
                        label="Done"
                        [color]="'primary'"
                        [variant]="'filled'"
                    ></mds-button>
                </div>
            </mds-dialog-actions>
        }
        @if (clinTrakVisits?.length === 0) {
            <mds-dialog-actions [align]="'end'">
                <mds-button
                    [id]="'ok-btn'"
                    mat-button
                    mat-dialog-close
                    label="Close"
                    variant="outline"
                    color="neutral"
                ></mds-button>
            </mds-dialog-actions>
        }
    </mds-dialog>
} @else {
    <div class="spinnerOverlay">
        <mds-spinner
            color="primary"
            class="loading-card"
            mode="indeterminate"
            [diameter]="100"
            [strokeWidth]="6"
        ></mds-spinner>
    </div>
}
